import { useContext, useEffect } from 'react'
import ChannelsContext from 'contexts/ChannelsContext'

export default function useChannel (channel, onError) {
  const {
    addChannel,
    removeChannel
  } = useContext(ChannelsContext)

  useEffect(() => {
    if (channel) {
      addChannel(channel, onError)

      return () => {
        removeChannel(channel)
      }
    }
  }, [channel, onError, addChannel, removeChannel])
}
